import React from 'react';
import config from '../../config/config.json';
import { Link } from 'react-router-dom';
import { getWebBaseUrl } from '../../functions'

export const Submenu = (props) => {
  const getProductName = (product) => config.products[product].productInfo.name;

  return (
    <div className="main-submenu-container">
      <div
        className={`main-submenu${
          props.isVisibleSubmenu === true ? ' is-visible' : ''
        }`}
      >
        <div className={`main-submenu__option theme-${props.theme} is-opened`}>
          <div className="main-submenu__separator" />
          <div className="main-submenu__content">
            {props.productsMenu.map((product, i) => (
              <div key={i} className="main-submenu__item">
                <Link
                  style={{ textDecoration: 'none' }}
                  to={`/presupuesto/${product}${props.qparams}`}
                  onClick={() => props.handleClick()}
                >
                  <h2 className="main-submenu__item-title">
                    {getProductName(product)}
                  </h2>
                </Link>
                <div className="u-margin-bottom u-only-up-tablet">
                  <a
                    rel="noopener noreferrer"
                    href={`${getWebBaseUrl()}/seguro/${product}`}
                    target="_blank"
                    className="link"
                  >
                    Más información
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Submenu;



// WEBPACK FOOTER //
// ./src/components/HorizontalMenu/Submenu.js